import 'bootstrap';
import 'jquery-match-height';

// import LazyLoad from "vanilla-lazyload";
import './js-components/mpam_process_product';

$.fn.materializeInputs = function(selectors) {

    if (typeof(selectors)==='undefined') selectors = "input, textarea";

    function setInputValueAttr(element) {
        element.setAttribute('value', element.value);

        if (!element.value || element.value === '') {
            $(element).parents('.input-material').removeClass('filled');
            $(element).parents('.input-material').find('label').removeClass('filled');
        } else {
            $(element).parents('.input-material').addClass('filled');
            $(element).parents('.input-material').find('label').addClass('filled');
        }
    }

    this.find(selectors).each(function () {
        setInputValueAttr(this);
    });

    this.on("keyup", selectors, function() {
        setInputValueAttr(this);
    });
};

(function($) {
    'use strict';

    // Focus Search if Searchform is empty
    $('.search-form').on('submit', function(e) {
        var search = $('#s');
        if (search.val().length < 1) {
            e.preventDefault();
            search.focus();
        }
    });

    /*var lazyLoadInstance = new LazyLoad({
        container: document.querySelector(".lazy"),
    });

    $(document).ajaxSuccess(function(event, xhr, settings ) {
        lazyLoadInstance.update();
    });*/


    function removeHash()  {
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    $("a[data-vc-accordion]").on("click", function(e) {
        e.preventDefault();
        setTimeout(function() {
        	removeHash();
        }, 100);
    });
  
    $("a.showlogin").on("click", function(e) {
        e.preventDefault();
        $('.woocommerce form.login').addClass('animated');
        setTimeout(function() {
            $('.woocommerce form.login').removeClass('animated');
        }, 2000);
    });



    var header = document.getElementById("header");
    var sticky = header.offsetTop;
    // var sticky = $(header).offset().top + $(header).height();
    function fixHeaderSticky() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

    $(document).ready(function() {
        fixHeaderSticky();
    });
    window.onscroll = function() {fixHeaderSticky()};

    $('body').materializeInputs();




    $(document).ready(function() {
        if ($('.wc_payment_methods, .payment_methods.methods')) {
            function toggleCurrentPaypentMethod() {
                setTimeout(function () {
                    $('.wc_payment_methods .wc_payment_method, .payment_methods.methods .wc_payment_method').removeClass('current');
                    $('.wc_payment_methods .wc_payment_method input[checked], .payment_methods.methods .wc_payment_method input[checked]').parents('.wc_payment_method').addClass('current');
                }, 100);
            }

            $(document).ajaxComplete(function () {
                toggleCurrentPaypentMethod();
            });
            $(document).on('click', '.wc_payment_methods label, .payment_methods.methods label', function() {
                $('.wc_payment_methods .wc_payment_method, .payment_methods.methods .wc_payment_method').removeClass('current');
                $(this).parents('.wc_payment_method').addClass('current');
            });
            toggleCurrentPaypentMethod();
        }
    });

}(jQuery));
